import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Categories } from "../components/Categories";
import { StickyCTA } from "../components/StickyCTA";
import { Footer } from "../components/Footer";

const SocialProof = lazy(() => import("../components/SocialProof").then((m) => ({ default: m.SocialProof })));
const FeaturedProducts = lazy(() => import("../components/FeaturedProducts").then((m) => ({ default: m.FeaturedProducts })));
const Specialist = lazy(() => import("../components/Specialist").then((m) => ({ default: m.Specialist })));
const SizeGuidance = lazy(() => import("../components/SizeGuidance").then((m) => ({ default: m.SizeGuidance })));
const HowItWorks = lazy(() => import("../components/HowItWorks").then((m) => ({ default: m.HowItWorks })));
const Installation = lazy(() => import("../components/Installation").then((m) => ({ default: m.Installation })));
const Assurance = lazy(() => import("../components/Assurance").then((m) => ({ default: m.Assurance })));
const LeadCapture = lazy(() => import("../components/LeadCapture").then((m) => ({ default: m.LeadCapture })));
const FAQ = lazy(() => import("../components/FAQ").then((m) => ({ default: m.FAQ })));
const FinalCTA = lazy(() => import("../components/FinalCTA").then((m) => ({ default: m.FinalCTA })));

export default function Home() {
  const location = useLocation();

  // Scroll to a section when arriving with a hash (e.g. from another page).
  useEffect(() => {
    const hash = location.hash || window.location.hash;
    if (hash && hash.length > 1) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
      }
    }
  }, [location]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Categories />
        <Suspense fallback={null}>
          <SocialProof />
          <FeaturedProducts />
          <Specialist />
          <SizeGuidance />
          <HowItWorks />
          <Installation />
          <Assurance />
          <LeadCapture />
          <FAQ />
          <FinalCTA />
        </Suspense>
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}